import { Tooltip, TooltipProps } from "@itk/mui-components";
import { Typography, TypographyProps } from "@mui/material";
import { useRef, useState } from "react";
import { isOverflowing } from "src/utils";

type Props = Omit<TypographyProps, "children"> & {
  text: string;
  placement?: TooltipProps["placement"];
};

export const TruncatedText = (props: Props) => {
  const { text, placement = "bottom-start", onMouseEnter, ...typographyProps } = props;

  const textRef = useRef<HTMLElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  // Measured on hover instead of in an effect or a ResizeObserver: these rows mount in the hundreds,
  // and reading scrollWidth forces a synchronous layout — only pay for it on the row being pointed at.
  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setIsTruncated(isOverflowing(textRef.current));
    onMouseEnter?.(event);
  };

  return (
    // Not disableHoverListener: at the instant the pointer enters, isTruncated is still stale, and a
    // tooltip whose listeners were disabled on that render never opens for that hover. An empty title
    // suppresses the popper on its own (MUI forces open=false) while the listeners stay attached.
    <Tooltip title={isTruncated ? text : ""} arrow placement={placement}>
      <Typography ref={textRef} onMouseEnter={handleMouseEnter} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" {...typographyProps}>
        {text}
      </Typography>
    </Tooltip>
  );
};
